module.exports = __webpack_public_path__ + "img/consultation.ee03590.webp";